// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  margin-top: 0.5rem;
  font-size: 1.25rem;
}

i {
  color: #000;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/wrappers/horizontal/horizontal-wrapper.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;AADF","sourcesContent":["@use 'mssvariables' as *;\n\nlabel {\n  margin-top: 0.5rem;\n  font-size: 1.25rem;\n}\n\ni {\n  color: theme-color('dark');\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
